module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"browser_title":"Girls","actress_list":"Girls"},"ja":{"browser_title":"女のコ一覧","actress_list":"女のコ一覧"}}')
  delete Component.options._Ctor
}
